export const TEMPLATE_VARIABLE_EXTENSION_TYPE = 'com.atlassian.template.extensions';
export const TEMPLATE_VARIABLE_EXTENSION_KEY = 'template-variable';
